/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import React from 'react';

import s from './Navigation.module.css';

type LegalItemProps = {
  to: string;
  children: React.ReactNode;
};

const LegalItem = ({ to, children }: LegalItemProps) => (
  <li className={s.legalItem}>
    <a href={to}>{children}</a>
  </li>
);

export { LegalItem };
